import { Spin } from 'antd'
import React from 'react'
import './index.less'
const Loading = () => (
  <div className="loading-wrapper">
    <Spin className="spin" tip="Loading..." size="large" />
  </div>
)

export default Loading
